{
  "#STORAGE_LOCATION": {
    "TITLE": "Lagerplatz-Artikel",
    "PAGES": {
      "SELECT_STORAGE_LOCATION": {
        "TITLE": "Lagerplatz auswählen"
      },
      "STORAGE_LOCATION_SEARCH_PRODUCTS": {
        "TITLE": "Artikel Suche"
      },
      "STORAGE_LOCATION_PRODUCTS": {
        "TITLE": "Lagerplatz Artikel",
        "PRINT_ALL": "Alle Artikel drucken"
      },
      "ARTIKEL_ITEM": {
        "TITLE": "Artikel"
      }
    }
  }
}
